const getIpData = function(ip){
    fetch("https://ipinfo.io/json?token=8296285bb58848")
      .then((response) => response.json())
      .then((data) => {
        const ipData = data
        today = new Date()
        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Token 5dcddce8448d76b147824d6aadb818bb45eaca5f");
        myHeaders.append("Content-Type", "application/json");
  
        var raw = JSON.stringify({
          "ip": data.ip,
          "date": today,
          "city": data.city,
          "region": data.region,
          "country_code": data.country,
          "lat_long": data.loc,
          "provider": data.org,
          "postal_prefix": data.postal,
          "time_zone": data.timezone
        });
  
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow',
          credentials: 'same-origin'
        };
        
        return fetch("https://72qpjq6a1e.execute-api.us-west-2.amazonaws.com/Test/catchVisitData", requestOptions);
        })
        .then(response => response.json())

      };
  
  
  
  
  getIpData()